/* Copyright 2021, Milkdown by Mirone. */
import { markFactory } from '@milkdown/core';
import { commonPlugin } from './base-common';
import { createKeymap } from './keymap';
export const createMark = (factory) => {
    const origin = (options) => {
        const plugin = markFactory((ctx) => {
            var _a;
            const mark = commonPlugin(factory, ctx, options);
            const view = (_a = options === null || options === void 0 ? void 0 : options.view) !== null && _a !== void 0 ? _a : mark.view;
            const keymap = createKeymap(mark.shortcuts, options === null || options === void 0 ? void 0 : options.keymap);
            return Object.assign(Object.assign({}, mark), { view,
                keymap });
        });
        plugin.origin = origin;
        return plugin;
    };
    return origin;
};
//# sourceMappingURL=base-mark.js.map